"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactWithLabelAndHelperMessage = _interopRequireDefault(require("@nerdwallet/react-with-label-and-helper-message"));

var _floatyInputModule = _interopRequireDefault(require("./floaty-input.module.css"));

var _excluded = ["error", "value", "isComponentFocused", "inputRef", "fixedLabel"];

var FloatyInput = function FloatyInput(_ref) {
  var _classNames;

  var error = _ref.error,
      value = _ref.value,
      isComponentFocused = _ref.isComponentFocused,
      inputRef = _ref.inputRef,
      fixedLabel = _ref.fixedLabel,
      otherProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var inputWrapperClasses = (0, _classnames.default)([_floatyInputModule.default['input-wrapper']], (_classNames = {}, (0, _defineProperty2.default)(_classNames, _floatyInputModule.default['underline-focused'], isComponentFocused), (0, _defineProperty2.default)(_classNames, _floatyInputModule.default['underline-error'], error), _classNames));
  var inputClasses = (0, _classnames.default)([_floatyInputModule.default.input], (0, _defineProperty2.default)({}, _floatyInputModule.default['placeholder-hidden'], !isComponentFocused && !error && !value && !fixedLabel));
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)((0, _defineProperty2.default)({}, _floatyInputModule.default['control-wrapper'], !fixedLabel))
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: inputWrapperClasses
  }, /*#__PURE__*/_react.default.createElement("input", (0, _extends2.default)({}, otherProps, {
    ref: inputRef,
    className: inputClasses,
    value: value
  }))));
};

FloatyInput.propTypes = {
  error: _propTypes.default.bool,
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  isComponentFocused: _propTypes.default.bool,
  fixedLabel: _propTypes.default.bool,
  inputRef: _propTypes.default.func
};

var _default = (0, _reactWithLabelAndHelperMessage.default)(FloatyInput);

exports.default = _default;